import { useParams } from 'react-router-dom'
import { Stack } from '@mui/material'
import { SPACING } from '@common/theme/spacing'
import { useGetStudyById } from '@study_setup/hooks/useStudyQueries'
import { useGetSubjectById } from '@features/study_details/Subjects/hooks/useStudySubjectsQueries'
import { useGetStudySubjectConfiguration } from '@study_setup/SubjectConfiguration/hooks/useStudySubjectConfigurationQueries'
import { useForm, FormProvider } from 'react-hook-form'
import { SubjectDetailsFormValues } from '@features/subject/subject.types'
import { useLoadStudySubjectDetails } from '@features/study_details/Subjects/hooks/useLoadStudySubjectDetails'
import SubjectInformation from './SubjectInformation'

export default function SubjectOverview() {
  const { studyId, subjectId } = useParams<{
    studyId: string
    subjectId: string
  }>()

  const { data: studyData, isLoading: isStudyLoading } = useGetStudyById(studyId!)

  const {
    data: subjectData,
    isError,
    isLoading: isSubjectLoading,
  } = useGetSubjectById({
    study_id: studyId!,
    subject_id: subjectId!,
  })

  const { data: studySubjectConfigData, isLoading: isSubjectConfigLoading } = useGetStudySubjectConfiguration(studyId!)

  const methods = useForm<SubjectDetailsFormValues>()
  useLoadStudySubjectDetails(methods, studyId!, subjectData, studySubjectConfigData)

  if (isStudyLoading || isSubjectLoading || isSubjectConfigLoading) {
    return <div>Loading...</div>
  }

  if (isError) {
    return <div data-testid="error-message">Failed to load subject</div>
  }

  return (
    <FormProvider {...methods}>
      <Stack spacing={SPACING.sectionsSpacing}>
        <SubjectInformation study={studyData} subjectConfig={studySubjectConfigData} />
      </Stack>
    </FormProvider>
  )
}
